import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MdDialogRef } from '@angular/material';

@Component({
  selector: 'app-add-company',
  templateUrl: './add-company.component.html',
  styleUrls: ['./add-company.component.scss']
})
export class AddCompanyComponent implements OnInit {
  public createCompanyForm;

  constructor(private dialogRef: MdDialogRef<AddCompanyComponent>,
              private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.createCompanyForm = this.formBuilder.group({
      name: ['', Validators.required],
      maxAllowedUsers: ['', [Validators.required, Validators.min(0)]]
    });
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onSaveClick(customerData) {
    this.dialogRef.close(customerData);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/admin/components/organisations/components/add-company/add-company.component.ts